// extracted by mini-css-extract-plugin
export default {"section":"AgreementTemplate_section__dkzWH"};